import { useQuery } from '@tanstack/react-query';
import type { MeterSearch, MeterSearchResponse } from '@metron/shared';
import { toMeterSearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search meter spec against `GET /meters/filter` (MET-3504).
 *
 * The query key is the serialized spec, so two specs that encode to the same
 * URL share a cache entry. The previous page stays on screen while the next
 * one loads, so paging and sorting don't flash an empty table.
 */
export function useMeterFilter(spec: MeterSearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toMeterSearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['meter-filter', params],
    queryFn: () => apiClient.get<MeterSearchResponse>(`meters/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
